export const COMPARE_REMOVE = '@OXD/COMPARE_REMOVE'
export const COMPARE_ADD = '@OXD/COMPARE_ADD'
export const COMPARE_CLOSE = '@OXD/COMPARE_CLOSE'
export const COMPARE_OPEN = '@OXD/COMPARE_OPEN'
